export default "__VITE_ASSET__DctQJB_W__"